import React from 'react'
import cloneDeep from 'lodash/cloneDeep'

import PageTemplate from 'templates/PageTemplate'
import FooterSection from 'sections/FooterSection/FooterSection'
import HeaderSectionContainer from 'sections/HeaderSection/HeaderSectionContainer'
import ProLoginForm from 'components/LoginForm/pro/LoginFormProContainer'

const ProLoginPage = props => {
  const newProps = cloneDeep(props)
  const urlParams = new URLSearchParams(window.location.search)

  if (urlParams.has('redirectPathname')) {
    newProps.redirectPathname = urlParams.get('redirectPathname')
  }

  return (
    <PageTemplate
      header={<HeaderSectionContainer layout="main" />}
      footer={<FooterSection />}
      noBackground
    >
      <ProLoginForm {...newProps} />
    </PageTemplate>
  )
}

export default ProLoginPage
